{
  "actions.cancel": "Abbrechen",
  "actions.confirm": "Bestätigen",
  "actions.save": "Speichern",
  "actions.delete": "Löschen",
  "actions.logout": "Ausloggen",
  "actions.language": "Sprache",
  "actions.support_request": "Support Anfrage",
  "actions.download": "Herunterladen",
  "actions.print": "Drucken",
  "documents.preview.cant_be_previewed": "Die Datei kann nicht in der Vorschau angezeigt werden.",
  "documents.preview.node_actions.pages": "{currentPage} von {totalPages} Seiten",
  "errors.error_occurred": "Ein Fehler ist aufgetreten",
  "article.new": "Neuer Knowledge Base Artikel",
  "article.create": "Artikel erstellen",
  "article.edit": "Artikel bearbeiten",
  "article.remove": "Artikel löschen",
  "article.state.draft": "Entwurf",
  "article.state.migrated": "Migriert",
  "article.state.published": "Publiziert",
  "article.state.delete-requested": "Löschung angefragt",
  "article.state.deleted": "Gelöscht",
  "article.visibility.internal": "Intern",
  "article.visibility.public": "Öffentlich",
  "folder.create": "Ordner erstellen",
  "folder.delete": "Ordner löschen",
  "folder.delete-confirmation": "Sind Sie sicher, dass Sie diesen Ordner löschen möchten?",
  "chat.title": "Chat",
  "chat.all": "Chat über alles",
  "chat.kb": "Chat KB",
  "chat.kb_attachment": "KB Anhang",
  "chat.ticket": "Ticket",
  "chat.jira": "Chat Jira",
  "title": "Titel",
  "problem": "Problem",
  "solution": "Lösung",
  "application": "Applikation",
  "affected-versions": "Betroffene Versionen",
  "from": "Von",
  "to": "Bis",
  "affected-servicepack": "Servicepack",
  "environment-system": "Umgebung / System",
  "parent-element": "Übergeordnetes Element",
  "visibility": "Sichtbarkeit",
  "created-by": "Erstellt von",
  "on": "am",
  "recently-edited-by": "Zuletzt bearbeitet von",
  "edit": "Bearbeiten",
  "review-migrations": "Migrations Review",
  "review": "Review",
  "confirm-delete": "Löschung bestätigen",
  "save-for-review": "Für Review speichern",
  "publish": "Veröffentlichen",
  "release": "Freigeben",
  "description-problem": "Beschreibung / Problem",
  "attachments": "Anhänge",
  "compare": "Vergleiche {left} - {right}",
  "all": "Alle",
  "unassigned": "Nicht zugewiesen",
  "id": "ID",
  "status": "Status",
  "last-editor": "Letzter Bearbeiter",
  "edited-at": "Bearbeitet am",
  "current": "Aktuell",
  "previous": "Vorherige",
  "editor": "Bearbeiter",
  "version": "Version",
  "compare-with": "Vergleichen mit",
  "main": "Allgemein",
  "versions": "Versionen",
  "request-removal": "Löschung anfragen",
  "yes-remove": "Ja, löschen",
  "remove": "Löschen",
  "retract": "Zurückziehen",
  "search": "Suchen ...",
  "please-specify-new-folder-name": "Bitte geben Sie den neuen Ordnernamen ein.",
  "name": "Name",
  "unable-to-create-new-folder-error": "Ordner konnte nicht erstellt werden: {0}",
  "knowledge-base": "Knowledge Base",
  "access-denied": "Keine Berechtigung",
  "article.article-needs-verification": "Der Artikel wird nach dem Speichern von einer anderen Person überprüft. Wählen Sie den gewünschten Benutzer aus.",
  "article.article-not-found": "Der Artikel wurde nicht gefunden.",
  "article.do-not-remove-article": "Artikel nicht löschen",
  "article.do-you-want-to-remove-this-article": "Möchten Sie diesen Artikel wirklich löschen? Dies kann nicht rückgängig gemacht werden.",
  "article.download-pdf": "Als PDF herunterladen",
  "article.removal-requires-approval": "Das Löschen des Artikels muss von einem Reviewer bestätigt werden. Wählen Sie den gewünschten Benutzer aus.",
  "article.watch-article": "Artikel merken",
  "article.watched": "Gemerkte Artikel",
  "article.watched-article": "Artikel gemerkt",
  "tickets.ticket-not-found": "Das Ticket wurde nicht gefunden",
  "tickets.state.draft": "Entwurf",
  "tickets.state.published": "Publiziert",
  "errors.check_your_inputs": "Überprüfen Sie Ihre Eingaben",
  "assigned": "Zugewiesen",
  "last-reviewer": "Letzter Reviewer",
  "page-guard.changes-not-saved": "Möchten Sie das Formular wirklich verlassen? Ihre vorgenommenen Änderungen werden dabei nicht gespeichert.",
  "page-guard.changes-not-saved-title": "Ungespeicherte Änderungen",
  "continue": "Fortfahren",
  "chat.delete_all": "Alle Chats löschen",
  "chat.no_chats_saved": "Keine Chats gespeichert",
  "chat.documents": "Dokumente",
  "chat.course_material": "Kursunterlagen",
  "chat.release_courses": "Neuerungskurse",
  "chat.misc_docs": "Weitere Unterlagen",
  "chat.news": "Partner-News",
  "chat.release_info": "Release-Informationen",
  "chat.f1_hilfe": "F1-Hilfe",
  "chat.new_chat": "Neuer Chat",
  "article.needs_transations": "Artikel braucht Übersetzungen",
  "languages.de": "Deutsch",
  "languages.en": "Englisch",
  "languages.fr": "Französisch",
  "languages.it": "Italienisch",
  "language-not-supported": "Sprache nicht unterstützt",
  "edit-translation": "Übersetzung bearbeiten",
  "save-translation": "Übersetzung speichern",
  "error": "Fehler",
  "article.versions.from": "Ab",
  "article.versions.to": "Bis",
  "servicepack": "Servicepack",
  "max-count": "max. {0}",
  "article.versions.from_to_entry": "Von / Bis erfassung",
  "select-applications": "Applikationen wählen",
  "load-applications": "Lade Applikationen",
  "select-servicepack": "Servicepack wählen",
  "load-servicepacks": "Lade Servicepacks",
  "select-version": "Version wählen",
  "load-versions": "Lade Versionen",
  "report": "Melden",
  "chat.reply_stopped": "Diese Antwort wurde angehalten",
  "open-source": "Quelle öffnen",
  "sources": "Quellen",
  "matches": "Treffer",
  "chat.sources_empty_text": "Sobald du eine Frage stellst, erscheinen hier die Quellen.",
  "chat.empty_text": "Wie kann ich dir heute helfen?",
  "hello": "Hallo",
  "chat.filter.collection.all": "Alles",
  "chat.prompt_placeholder": "Stelle deine Frage",
  "send": "Senden",
  "chat.report_answer": "Antwort melden",
  "chat.your_message": "Ihre Mitteilung",
  "chat.diagram_loading": "Diagramm wird erstellt…",
  "chat.diagram_open": "Diagramm öffnen",
  "chat.diagram_filename": "diagramm.png",
  "cancel": "Abbrechen",
  "refresh": "Aktualisieren",
  "to-migrate": "Zu migrieren",
  "not-assigned": "Nicht zugewiesen",
  "to-do": "Zu erledigen",
  "article.dashboard.external_user.welcome_text": "Um den gesuchten Knowledge Base Artikel zu finden, verwende das Suchfeld oder wähle eine Kategorie aus.",
  "last-updated": "Zuletzt aktualisiert",
  "old": "Alt",
  "new": "Neu",
  "summary": "Zusammenfassung",
  "tickets.support_request": "Support Anfrage",
  "clarifications": "Abklärungen",
  "to-review": "Zu prüfen",
  "tickets.ticket_no": "Ticket Nr.",
  "date": "Datum",
  "tickets.needs_transations": "Ticket braucht Übersetzungen",
  "users.group_search_or_select": "Gruppe suchen oder auswählen",
  "users.favorites": "Favoriten",
  "users.all_users": "Alle Benutzer",
  "users.favorite_add": "Zu Favoriten hinzufügen",
  "users.favorite_remove": "Aus Favoriten entfernen",
  "users.user_search_or_select": "Benutzer suchen oder auswählen",
  "admin.title": "Admin",
  "admin.chat.reports": "Chat Meldungen",
  "article.errors.save_conflict": "Der Artikel wurde zwischenzeitlich von jemand anderem bearbeitet. Bitte lade die Seite neu und versuche es erneut.",
  "tickets.errors.save_conflict": "Das Ticket wurde zwischenzeitlich von jemand anderem bearbeitet. Bitte lade die Seite neu und versuche es erneut.",
  "project": "Projekt",
  "article.language.alert.translation_text": "{lang} Übersetzung dieses Artikels.",
  "article.language.alert.english": "Englische",
  "article.language.alert.french": "Französische",
  "article.language.alert.italian": "Italienische",
  "article.language.alert.only_relevant_fields": "Es werden nur relevante Felder für die Übersetzung angezeigt.",
  "article.language.show_original": "Original einblenden (DE)",
  "article.language.original_article": "Original Artikel (DE)",
  "admin.chat.table_headers.report": "Meldung",
  "admin.chat.table_headers.chat_filter": "Chat Filter",
  "admin.chat.table_headers.reported_by": "Gemeldet von",
  "admin.chat.table_headers.reported_on": "Gemeldet am",
  "admin.chat.detail_title": "Chat Meldung Detail",
  "tickets.back_to_list": "Zurück zur Liste",
  "tickets.show_old": "ALT einblenden",
  "filter": "Filter",
  "my-employee-group": "Meine MA Gruppe",
  "preview": "Vorschau",
  "preview.previous_attachment": "Vorheriger Anhang",
  "preview.next_attachment": "Nächster Anhang",
  "article.restore_this_revision": "Diese Version wiederherstellen",
  "page-guard.back-to-form": "Zurück zum Formular",
  "page-guard.discard-changes": "Änderungen verwerfen",
  "time.just_now": "gerade eben",
  "time.yesterday_at": "gestern um",
  "is-saving": "Wird gespeichert",
  "last-saved": "Zuletzt gespeichert",
  "article.discard_my_changes": "Meine Änderungen verwerfen",
  "article.no_changes_yet": "noch keine Änderungen",
  "actions.close": "Schliessen",
  "article.autosave.hint_not_up_to_date": "Dieser Artikel wurde inzwischen von jemand anderem bearbeitet. Daher könnten deine Änderungen veraltet sein. Du kannst deine Änderungen verwerfen um dann den aktuellen Stand zu bearbeiten.",
  "article.autosave.hint_saved_changes": "Sie haben gespeicherte Änderungen für diesen Artikel.",
  "outdated": "Veraltet",
  "article.autosave.version_status": "Stand",
  "article.autosave.pending_changes": "Meine offenen Änderungen",
  "article.autosave.load_error": "Dein gespeicherter Zwischenstand konnte nicht geladen werden. Möchten Sie den Artikel trotzdem öffnen? Dein gespeicherter Zwischenstand könnte überschrieben werden.",
  "open-anyway": "Trotzdem öffnen",
  "article.autosave.show_my_changes": "Meine Änderungen anzeigen",
  "article.migrated_alert": "Dieser Artikel wurde seit der Migration von der alten KB noch nicht überarbeitet.",
  "development": "Entwicklung",
  "select-reviewer": "Reviewer auswählen",
  "users.select_group_text": "Wählen Sie die gewünschte Gruppe aus.",
  "tickets.state.not_relevant": "Nicht relevant",
  "tickets.state.migrated": "Migriert",
  "tickets.state.not_relevant_requested": "Nicht relevant angefragt",
  "tickets.unused_requires_approval": "Diese Aktion muss von einem Reviewer bestätigt werden. Wählen Sie den gewünschten Benutzer aus.",
  "tickets.change_to_relevant": "Zu Relevant ändern",
  "tickets.confirm_not_relevant": "Nicht relevant bestätigen",
  "tickets.ticket_not_relevant": "Ticket ist nicht relevant",
  "count-selected": "{0} selektiert",
  "assign": "Zuweisen",
  "assign-group": "Gruppe zuweisen",
  "group": "Gruppe",
  "users.select_user_text": "Wählen Sie den gewünschten Benutzer aus.",
  "tickets.assign_ticket_count": "{0} Tickets zuweisen",
  "tickets.assign_group_count": "{0} Tickets einer Gruppe zuweisen",
  "chat.delete_all_msg": "Sind Sie sicher, dass Sie alle Chats löschen möchten?",
  "chat.deleta_all_confirm": "Ja, löschen",
  "reject": "Zurückweisen",
  "folder.rename": "Ordner umbenennen",
  "unable-to-rename-folder-error": "Ordner konnte nicht umbenannt werden: {0}",
  "move": "Verschieben",
  "yes-move": "Ja, verschieben",
  "tree.really_move": "Möchten Sie wirklich <b>{0}</b> nach <b>{1}</b> verschieben?",
  "tree.folder_to_kb_warning": "Ein Verzeichnis kann nicht in eine KB verschoben werden.",
  "tree.really_move_to_root": "Möchten Sie wirklich <b>{0}</b> auf die <b>oberste Ebene</b> verschieben?",
  "tree.hint_search_result": "{0} von {1} Ergebnissen",
  "nothing-found": "Nichts gefunden",
  "tickets.keep_original": "Original Ticket übernehmen",
  "article.visibility.c3_internal_it": "C3 Internal IT",
  "article.visibility.c3_deepcloud": "C3 DeepCloud",
  "description": "Beschreibung",
  "jira.jira_not_found": "Das Jira Ticket wurde nicht gefunden oder Sie haben keinen Zugriff.",
  "jira.labels.components": "Komponente(n)",
  "jira.labels.solution_versions": "Lösungsversion(en)",
  "created": "Erstellt",
  "author": "Autor",
  "priority": "Priorität",
  "jira.labels.external_contacts": "Externe Kontakte",
  "jira.labels.affected_versions": "Betrifft Version(en)",
  "last-modified": "Letzte Änderung",
  "details": "Details",
  "type": "Typ",
  "modified": "Geändert",
  "kb.edit.insert-attachment-link": "Anhang",
  "comments": "Kommentare",
  "jira.comments.edited": "bearbeitet",
  "jira.comments.no_comments": "Noch keine Kommentare",
  "jira.comments.sort_newest_first": "Neuste zuerst",
  "jira.comments.sort_oldest_first": "Älteste zuerst",
  "save": "Speichern",
  "change-status": "Status ändern",
  "admin.chat.status.new": "Neu",
  "admin.chat.status.read": "Gelesen",
  "admin.chat.status.in_progress": "In Bearbeitung",
  "admin.chat.status.fixed": "Behoben",
  "admin.chat.status.wont_fix": "Wird nicht behoben",
  "admin.chat.set_status_dialog.note": "Notiz (optional)",
  "admin.chat.admin_note": "Admin-Notiz",
  "admin.chat.handled_by": "Bearbeitet von {name} am {date}",
  "watchers": "Beobachter",
  "jira.errors.watchers_refresh": "Die Liste der Beobachter konnte nicht aktualisiert werden",
  "jira.no_watchers_yet": "Noch keine Beobachter",
  "jira.watched": "Beobachtet",
  "jira.watch": "Beobachten",
  "jira.filter.only_watched": "Nur Beobachtete",
  "jira.no_attachments": "Keine Anhänge",
  "jira.links.title": "Verknüpfungen",
  "jira.links.remote_group": "ist verknüpft mit",
  "jira.links.no_links": "Keine Verknüpfungen",
  "notifications.settings.title": "E-Mail Benachrichtigungen",
  "notifications.settings.description": "Wählen Sie aus, für welche Ereignisse Sie per E-Mail benachrichtigt werden möchten.",
  "notifications.settings.saved": "Einstellungen aktualisiert",
  "notifications.settings.event_type.kb_followed_article_changed": "Änderungen an gefolgten KB-Artikeln",
  "notifications.settings.event_type.kb_review_approved": "Freigabe eines bearbeiteten KB-Artikels",
  "notifications.settings.event_type.kb_review_rejected": "Ablehnung eines bearbeiteten KB-Artikels",
  "notifications.settings.event_type.kb_assigned": "Zuweisung eines KB-Artikels",
  "notifications.settings.event_type.ticket_review_approved": "Freigabe eines bearbeiteten Tickets",
  "notifications.settings.event_type.ticket_review_rejected": "Einstufung eines bearbeiteten Tickets als nicht brauchbar",
  "notifications.settings.event_type.ticket_assigned": "Zuweisung eines Tickets",
  "notifications.settings.event_type.jira_followed_issue_updated": "Änderungen an gefolgten Jira-Issues",
  "tickets.state.not_relevant_ai": "Nicht relevant (KI)",
  "wish_ticket.open": "Wunschformular",
  "wish_ticket.title": "Wünsche in der Applikation",
  "wish_ticket.email": "E-Mail",
  "wish_ticket.customer_name": "Kundenname",
  "wish_ticket.customer_license": "Kundenlizenz",
  "wish_ticket.section_description": "Wunschbeschreibung",
  "wish_ticket.description": "Genaue Beschreibung der Anforderung (Ausgangslage, aktuelles Verhalten vs. erwartetes Verhalten)",
  "wish_ticket.use_cases": "Welche Use-Cases (UserStories) sollen damit abgedeckt / unterstützt werden?",
  "wish_ticket.frequency.label": "Wie oft kommt dieser Use-Case vor? Wie oft könnte die neue Funktion genutzt werden?",
  "wish_ticket.frequency.multiple_per_day": "Häufig (mehrmals pro Tag)",
  "wish_ticket.frequency.multiple_per_week": "Oft (mehrmals pro Woche)",
  "wish_ticket.frequency.weekly_monthly": "Regelmässig (1x pro Woche/Monat)",
  "wish_ticket.frequency.rarely": "Selten (1x pro Jahr, gelegentlich)",
  "wish_ticket.frequency.once": "Einmalig",
  "wish_ticket.target_audience": "Für wen ist die neue Funktion gedacht? (z.B. Buchhalter, Mitarbeiter, Vertriebspartner, Treuhänder, usw.)",
  "wish_ticket.benefit": "Welcher Gesamtnutzen kann aus dieser Erweiterung gezogen werden? (z.B. Prozessvereinfachung, Effizienzgewinnung, Automatisierung...usw.)",
  "wish_ticket.discussed_with_abacus": "Wurde der Wunsch bereits mit jemandem bei der Abacus Research AG besprochen?",
  "wish_ticket.yes": "Ja",
  "wish_ticket.no": "Nein",
  "wish_ticket.additional_info": "Weitere Informationen (Mit wem wurde das besprochen? Gibt es bereits einen bekannten Jira oder KB?)",
  "wish_ticket.privacy": "Datenschutz",
  "wish_ticket.privacy_text": "Ich habe die {link} zur Kenntnis genommen.",
  "wish_ticket.privacy_link": "Datenschutzerklärung",
  "wish_ticket.submit": "Wunsch senden",
  "wish_ticket.sent": "Ihr Wunsch wurde gesendet",
  "wish_ticket.please_select": "– bitte auswählen –",
  "live_status.button": "Status",
  "live_status.title": "Servicestatus",
  "live_status.all_ok": "Alle Systeme betriebsbereit",
  "live_status.issue": "Einige Dienste sind beeinträchtigt",
  "live_status.unreachable": "Servicestatus konnte nicht abgerufen werden",
  "live_status.loading": "Servicestatus wird geladen…",
  "ops.cases": "Fälle",
  "ops.case.create": "Fall erfassen",
  "ops.case.delete": "Fall löschen",
  "ops.case.delete_confirmation": "Möchten Sie diesen Fall wirklich löschen? Er verschwindet aus allen Listen und aus dem Chat.",
  "ops.case.deleted": "Fall gelöscht",
  "ops.case.saved": "Fall gespeichert",
  "ops.case.load_error": "Der Fall konnte nicht geladen werden.",
  "ops.case.required": "Pflichtfeld",
  "ops.case.case_no": "Fallnummer",
  "ops.case.case_no_pending": "Wird beim Speichern vergeben",
  "ops.case.folder": "Ordner",
  "ops.case.reported_at": "Datum der Meldung",
  "ops.case.affected_users": "Betroffene Benutzer",
  "ops.case.os": "OS",
  "ops.case.os_build": "OS-Build",
  "ops.case.version_patch": "Abacus-Version / Patch",
  "ops.case.applications": "Betroffene Applikationen",
  "ops.case.frequency": "Häufigkeit / Regelmässigkeit",
  "ops.case.frequency_hint": "z. B. jeden Mittag, immer am 24.",
  "ops.case.programs": "Betroffene Programme",
  "ops.case.services": "Betroffene Dienste",
  "ops.case.required_data": "Benötigte Daten für Analyse",
  "ops.case.required_data_hint": "z. B. Heapdump und Sysinfo",
  "ops.case.jira_keys": "Betroffene Jiras",
  "ops.case.ticket_numbers": "Betroffene Tickets",
  "ops.case.workarounds": "Workarounds",
  "ops.case.solutions": "Lösungen",
  "ops.analysis.title": "Analysen",
  "ops.analysis.add": "Analyse hinzufügen",
  "ops.analysis.count": "Analysen",
  "ops.analysis.empty": "Noch keine Analysen erfasst.",
  "ops.analysis.entry_title": "Analyse {0}",
  "ops.analysis.saved": "Analyse gespeichert",
  "ops.analysis.delete": "Analyse löschen",
  "ops.analysis.delete_confirmation": "Möchten Sie diese Analyse inklusive ihrer Dateien wirklich löschen?",
  "ops.analysis.cpu": "CPU",
  "ops.analysis.memory": "Memory",
  "ops.analysis.diskspeed": "Diskspeed",
  "ops.analysis.abacus_services": "Abacus-Services",
  "ops.analysis.procedure": "Analyse / Vorgehen",
  "ops.analysis.log_entries": "Logeinträge",
  "ops.analysis.thread_stack": "Entscheidender Threadstack",
  "ops.analysis.heapdump_ref": "Heapdump-Referenz",
  "ops.analysis.heapdump_ref_hint": "Pfad oder Link zum Heapdump (kein Upload)",
  "ops.files.title": "Dateien (Threaddump, Prometheus-Dump, …)",
  "ops.files.hint": "Max. {0} pro Datei",
  "ops.files.too_large": "«{0}» ist grösser als {1} und kann nicht hochgeladen werden. Verkleinern oder teilen Sie die Datei.",
  "servicepack_none": "Keine Servicepacks",
  "ops.case.folder_root": "Oberste Ebene (kein Ordner)",
  "ops.analysis.edit": "Analyse bearbeiten",
  "ops.analysis.files_after_save": "Speichern Sie die Analyse zuerst, um Dateien anzuhängen.",
  "ops.analysis.no_details": "Keine Angaben erfasst.",
  "ops.analysis.file_count": "{0} Datei(en)",
  "ops.case.edit": "Fall bearbeiten",
  "ops.case.affected_users_hint": "Anzahl"
}
